import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

function Navigation() {
  const location = useLocation();

  const navItems = [
    { path: '/homepage', label: 'Anasayfa' },
    { path: '/features', label: 'Özellikler' },
    { path: '/guide', label: 'Kullanım Rehberi' },
    { path: '/devices', label: 'Desteklenen Cihazlar' },
    { path: '/references', label: 'Referanslar' },
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/analytics', label: 'Analitikler' },
    { path: '/settings', label: 'Ayarlar' },
    { path: '/users', label: 'Kullanıcılar' }
  ];

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/homepage" className="brand-link">
            <span className="brand-text">Enerji Takip</span>
          </Link>
        </div>
        
        <div className="nav-menu">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </div>
        
        <div className="nav-actions">
          <Link to="/login" className="login-button">
            <span className="login-text">Giriş Yap</span>
          </Link>
        </div>
        
        <div className="nav-mobile-toggle">
          <button className="mobile-menu-button">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
